import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AccountsPage from "pages/accounts/AccountsPage";
import AccountAddPage from "pages/accounts/AccountAddPage";
import AccountEditPage from "pages/accounts/AccountEditPage";
import DashboardPage from "pages/dashboard/DashboardPage";
import HomePage from "pages/home/HomePage";
import RechargePage from "pages/recharge/RechargePage";
import RechargeAddPage from "pages/recharge/RechargeAddPage";
import DailyReportPage from "pages/reports/DailyReportPage";
import BkashTransactionsPage from "pages/transactions/BkashTransactionsPage";
import UpayTransactionsPage from "pages/transactions/UpayTransactionsPage";
import WaterTransactionsPage from "pages/transactions/WaterTransactionsPage";
import CardsPage from "pages/cards/CardsPage";
import CardAddPage from "pages/cards/CardAddPage";
import CardEditPage from "pages/cards/CardEditPage";
import ComingSoonPage from "pages/placeholders/ComingSoonPage";
import SettingsPage from "pages/settings/SettingsPage";
import PumpRechargePage from "pages/settings/PumpRechargePage";
import DeviceLogsPage from "pages/settings/DeviceLogsPage";

const comingSoonRoutes = [
  { path: "/logs", title: "Logs" },
  { path: "/reports", title: "Reports" },
];

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/accounts" element={<AccountsPage />} />
      <Route path="/accounts/new" element={<AccountAddPage />} />
      <Route path="/accounts/:id/edit" element={<AccountEditPage />} />
      <Route path="/reports/daily" element={<DailyReportPage />} />
      <Route path="/recharge" element={<RechargePage />} />
      <Route path="/recharge/new" element={<RechargeAddPage />} />
      <Route path="/transactions/bkash" element={<BkashTransactionsPage />} />
      <Route path="/transactions/upay" element={<UpayTransactionsPage />} />
      <Route
        path="/transactions/water"
        element={<WaterTransactionsPage />}
      />
      <Route path="/cards" element={<CardsPage />} />
      <Route path="/cards/new" element={<CardAddPage />} />
      <Route path="/cards/:id/edit" element={<CardEditPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/pump-recharge" element={<PumpRechargePage />} />
      <Route path="/settings/device-logs" element={<DeviceLogsPage />} />
      {comingSoonRoutes.map(({ path, title }) => (
        <Route
          key={path}
          path={path}
          element={<ComingSoonPage title={title} />}
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
